import EventEmitter from "event-lite";

import { IS_TESTING } from "@/__main__/constants.mjs";

const EMITTER_TIMEOUT = 5 * 1000;

export class StrictEventEmitter extends EventEmitter {
  // Return a promise that resolves when all listeners have finished running.
  async emit(name, ...args) {
    const listeners = this.listeners[name];

    if (!listeners) {
      return false;
    }

    const listenersPromise = Promise.all(
      listeners.map((listener) => {
        return listener.call(this, ...args);
      }),
    );

    const promises = [listenersPromise];

    // Testing doesn't like this timeout.
    if (!IS_TESTING) {
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error(`Emittter timeout for event type "${name}"`));
        }, EMITTER_TIMEOUT);
      });

      promises.push(timeoutPromise);
    }

    await Promise.race(promises);

    return true;
  }
}
